<template>
  <div class="submitBusiness">
    <Steps :active="2" addType="merchant"></Steps>
    <van-field
      v-model="business.mercName"
      type="text"
      label="商户名称"
      input-align="right"
      error-message-align="right"
      :placeholder="placeholder"
      @blur="validateMercName"
      :error-message="errorMessage"
    />
    <van-field
      v-model="business.shortName"
      type="text"
      label="商户简称"
      input-align="right"
      error-message-align="right"
      placeholder="请输入商户简称"
      @blur="validateShortName"
      :error-message="error_shortName"
    />
    <van-cell title-class="van-field__label" value-class="leftText"
        title="所在地区" is-link :value="accArea" @click="changeAddress"/>
    <van-field
      v-model="business.owAddress"
      type="text"
      label="详细地址"
      input-align="right"
      placeholder="请输入详细地址"
    />
    <template v-if="$store.state.merchantType !== '2'">
      <van-cell title-class="cell_left_text" @click="selectScop" value-class="leftText"
          title="经营范围" is-link :value="business.scopBus" />
      <van-field
        v-model="business.comArea"
        type="text"
        label="经营面积"
        input-align="right"
        placeholder="请输入经营面积(m²)"
      />
      <van-field
        v-model="business.busLicNo"
        label="营业执照号"
        input-align="right"
        placeholder="请输入营业执照号"
      />
      <van-cell title-class="cell_left_text" @click="selectDate('busDateStart')" value-class="leftText"
          title="营业执照有效期起" is-link :value="business.busDateStart" />

      <van-cell title-class="cell_left_text" @click="selectDate('busDateEnd')" value-class="leftText"
          title="营业执照有效期止" is-link :value="business.busDateEnd" />
      
      <p class="title">营业执照照片</p>
      <van-uploader v-if="isIos" name="businessLicenceUrl" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传营业执照照片</p>
          </div>
          <img :src="imgSrc.businessLicenceUrl" v-if="imgSrc.businessLicenceUrl" class="previewImg">
          <img v-if="isUploadSuccess.businessLicenceUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.businessLicenceUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
      <van-uploader v-if="isAndroid" name="businessLicenceUrl" accept="image/*"
          capture="camera" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传营业执照照片</p>
          </div>
          <img :src="imgSrc.businessLicenceUrl" v-if="imgSrc.businessLicenceUrl" class="previewImg">
          <img v-if="isUploadSuccess.businessLicenceUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.businessLicenceUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>

      <p class="title">门头(场地)照片</p>
      <van-uploader v-if="isIos" name="doorUrl" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传门头(场地)照片</p>
          </div>
          <img :src="imgSrc.doorUrl" v-if="imgSrc.doorUrl" class="previewImg">
          <img v-if="isUploadSuccess.doorUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.doorUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
      <van-uploader v-if="isAndroid" name="doorUrl" accept="image/*"
          capture="camera" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传门头(场地)照片</p>
          </div>
          <img :src="imgSrc.doorUrl" v-if="imgSrc.doorUrl" class="previewImg">
          <img v-if="isUploadSuccess.doorUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.doorUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
    </template>
    
    <template v-if="$store.state.merchantType === '1'">
      <p class="title">收银台或财务室照片</p>
      <van-uploader v-if="isIos" name="cashierUrl" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传收银台或财务室照片</p>
          </div>
          <img :src="imgSrc.cashierUrl" v-if="imgSrc.cashierUrl" class="previewImg">
          <img v-if="isUploadSuccess.cashierUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.cashierUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
      <van-uploader v-if="isAndroid" name="cashierUrl" accept="image/*"
          capture="camera" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传收银台或财务室照片</p>
          </div>
          <img :src="imgSrc.cashierUrl" v-if="imgSrc.cashierUrl" class="previewImg">
          <img v-if="isUploadSuccess.cashierUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.cashierUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>

      <p class="title">店内照片</p>
      <van-uploader v-if="isIos" name="shopUrl" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传店内照片</p>
          </div>
          <img :src="imgSrc.shopUrl" v-if="imgSrc.shopUrl" class="previewImg">
          <img v-if="isUploadSuccess.shopUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.shopUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
      <van-uploader v-if="isAndroid" name="shopUrl" accept="image/*"
          capture="camera" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传店内照片</p>
          </div>
          <img :src="imgSrc.shopUrl" v-if="imgSrc.shopUrl" class="previewImg">
          <img v-if="isUploadSuccess.shopUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.shopUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
    </template>

    <template v-if="$store.state.merchantType === '0'">
      <p class="title">办公区域照片</p>
      <van-uploader v-if="isIos" name="officeAreaUrl" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传办公区域照片</p>
          </div>
          <img :src="imgSrc.officeAreaUrl" v-if="imgSrc.officeAreaUrl" class="previewImg">
          <img v-if="isUploadSuccess.officeAreaUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.officeAreaUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
      <van-uploader v-if="isAndroid" name="officeAreaUrl" accept="image/*"
          capture="camera" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传办公区域照片</p>
          </div>
          <img :src="imgSrc.officeAreaUrl" v-if="imgSrc.officeAreaUrl" class="previewImg">
          <img v-if="isUploadSuccess.officeAreaUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.officeAreaUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>

      <p class="title">所在市场或写字楼照片</p>
      <van-uploader v-if="isIos" name="outsideOfficeBuildingUrl" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传所在市场或写字楼照片</p>
          </div>
          <img :src="imgSrc.outsideOfficeBuildingUrl" v-if="imgSrc.outsideOfficeBuildingUrl" class="previewImg">
          <img v-if="isUploadSuccess.outsideOfficeBuildingUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.outsideOfficeBuildingUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
      <van-uploader v-if="isAndroid" name="outsideOfficeBuildingUrl" accept="image/*"
          capture="camera" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传所在市场或写字楼照片</p>
          </div>
          <img :src="imgSrc.outsideOfficeBuildingUrl" v-if="imgSrc.outsideOfficeBuildingUrl" class="previewImg">
          <img v-if="isUploadSuccess.outsideOfficeBuildingUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.outsideOfficeBuildingUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>

      <p class="title">财务室照片</p>
      <van-uploader v-if="isIos" name="financialRoomPic" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传财务室照片</p>
          </div>
          <img :src="imgSrc.financialRoomPic" v-if="imgSrc.financialRoomPic" class="previewImg">
          <img v-if="isUploadSuccess.financialRoomPic === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.financialRoomPic === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
      <van-uploader v-if="isAndroid" name="financialRoomPic" accept="image/*"
          capture="camera" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传财务室照片</p>
          </div>
          <img :src="imgSrc.financialRoomPic" v-if="imgSrc.financialRoomPic" class="previewImg">
          <img v-if="isUploadSuccess.financialRoomPic === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.financialRoomPic === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
    </template>

    <template v-if="$store.state.merchantType !== '2'">
      <p class="title">红盾网截图</p>
      <van-uploader v-if="isIos" name="redbeanUrl" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传红盾网截图照片</p>
          </div>
          <img :src="imgSrc.redbeanUrl" v-if="imgSrc.redbeanUrl" class="previewImg">
          <img v-if="isUploadSuccess.redbeanUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.redbeanUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
      <van-uploader v-if="isAndroid" name="redbeanUrl" accept="image/*"
          capture="camera" class="uploader" :after-read="onRead">
        <div class="cameraBox">
          <div>
            <img src="@/assets/camera.png" />
            <p>请上传红盾网截图照片</p>
          </div>
          <img :src="imgSrc.redbeanUrl" v-if="imgSrc.redbeanUrl" class="previewImg">
          <img v-if="isUploadSuccess.redbeanUrl === '0'" src="@/assets/auth_pic_suc.png" class="statusImg">
          <img v-if="isUploadSuccess.redbeanUrl === '1'" src="@/assets/auth_pic_fail.png" class="statusImg">
        </div>
      </van-uploader>
    </template>
    <button class="btn" @click="gotoAccountInfo">下一步</button>
    <van-popup v-model="scopBusShow" position="bottom" class="bottomPopup">
      <van-tree-select
        :items="items"
        :main-active-index="mainActiveIndex"
        :active-id="activeId"
        @navclick="onNavClick"
        @itemclick="onItemClick"
      />
    </van-popup>
    <van-popup v-model="show_time" position="bottom">
      <van-datetime-picker
        :max-date="maxDate"
        @confirm="sureClick_time"
        @cancel="cancelClick"
        v-model="currentDate"
        type="date"
      />
    </van-popup>
    <van-popup v-model="show_area" position="bottom" :style="{ height: '50%' }">
      <area-select @confirm="confirm"></area-select>
    </van-popup>
  </div>
</template>

<script>
import { Field, Cell, Popup, Uploader, Area, DatetimePicker, List, Button, TreeSelect } from 'vant';
import Steps from '@/components/Steps.vue';
import AreaSelect from '@/components/AreaSelect.vue';
export default {
  name: 'merchant_submitBusiness',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Uploader.name]: Uploader,
    [DatetimePicker.name]: DatetimePicker,
    [Area.name]: Area,
    [List.name]: List,
    [Button.name]: Button,
    [TreeSelect.name]: TreeSelect,
    Steps,
    AreaSelect
  },
  data() {
    return {
      errorMessage: '',
      error_shortName: '',
      isAndroid: false,
      isIos: false,
      imgSrc: {
        businessLicenceUrl: '',
        doorUrl: '',
        cashierUrl: '',
        shopUrl: '',
        officeAreaUrl: '',
        outsideOfficeBuildingUrl: '',
        financialRoomPic: '',
        redbeanUrl: ''
      },
      placeholder: '',
      business: {
        mercName: '',
        shortName: '',
        owAddress: '',
        provinceId: '',
        provinceName: '',
        cityName: '',
        cityNo: '',
        countyName: '',
        countyId: ''
      },
      errorNotice: {
        mercName: '请输入商户名称',
        shortName: '请输入商户简称',
        owAddress: '请输入详细地址',
        provinceId: '请选择所在地区',
        provinceName: '请选择所在地区',
        cityName: '请选择所在地区',
        cityNo: '请选择所在地区',
        countyName: '请选择所在地区',
        countyId: '请选择所在地区',
        comArea: '请输入经营面积',
        scopBus: '请选择经营范围',
        busLicNo: '请输入营业执照号',
        busDateStart: '请选择营业执照有效期',
        busDateEnd: '请选择营业执照有效期',
        businessLicenceUrl: '请上传营业执照',
        doorUrl: '请上传门头(场地)照片',
        cashierUrl: '请上传收银台或财务室照片',
        shopUrl: '请上传店内照片',
        redbeanUrl: '请上传红盾网截图',
        officeAreaUrl: '请上传办公区域照片',
        outsideOfficeBuildingUrl: '请上传所在市场或写字楼照片',
        financialRoomPic: '请上传财务室照片'
      },
      accArea: '',
      isUploadSuccess: {
        businessLicenceUrl: '2',
        doorUrl: '2',
        cashierUrl: '2',
        shopUrl: '2',
        officeAreaUrl: '2',
        outsideOfficeBuildingUrl: '2',
        redbeanUrl: '2',
        financialRoomPic: '2'
      },
      currentDate: new Date(),
      show_time: false,
      show_area: false,
      key: '',
      loading: '',
      maxDate: new Date('2080-12-31'),
      imgType: '',
      scopBusShow: false,
      items: [],
      mainActiveIndex: 0,
      activeId: 1
    };
  },
  created() {
    if (/android/i.test(navigator.userAgent)) {
      this.isAndroid = true;
    };
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      this.isIos = true;
    };
    if (this.$store.state.merchantType === '0') {
      this.placeholder = '请输入商户名称';
    } else {
      this.placeholder = '格式应为：地区+个体户+姓名';
    }
    this.queryCateType();
  },
  activated() {
    const mercType_2 = {
      mercName: '',
      shortName: '',
      owAddress: '',
      provinceId: '',
      provinceName: '',
      cityName: '',
      cityNo: '',
      countyName: '',
      countyId: ''
    };
    const mercType_0_1 = {
      comArea: '',
      scopBus: '',
      busLicNo: '',
      busDateStart: '',
      busDateEnd: '',
      businessLicenceUrl: '',
      doorUrl: '',
      redbeanUrl: ''
    };
    const mercType_1 = Object.assign({}, mercType_2, mercType_0_1, {
      cashierUrl: '',
      shopUrl: ''
    });
    const mercType_0 = Object.assign({}, mercType_2, mercType_0_1, {
      officeAreaUrl: '',
      outsideOfficeBuildingUrl: '',
      financialRoomPic: ''
    });
    Object.keys(mercType_2).forEach(key => {
      mercType_2[key] = this.business[key];
    });

    if (this.$store.state.merchantType === '2') {
      this.business = Object.assign({}, mercType_2);
    }

    if (this.$store.state.merchantType === '1') {
      Object.keys(mercType_1).forEach(key => {
        mercType_1[key] = this.business[key] || '';
      });
      this.business = Object.assign({}, mercType_1);
    }

    if (this.$store.state.merchantType === '0') {
      Object.keys(mercType_0).forEach(key => {
        mercType_0[key] = this.business[key] || '';
      });
      this.business = Object.assign({}, mercType_0);
    }
    const detail = this.$store.state.merchantDetail;
    if (detail.pmmerId) {
      Object.keys(this.business).forEach(key => {
        this.business[key] = detail[key] || '';
      });
      Object.keys(this.imgSrc).forEach(key => {
        this.imgSrc[key] = detail[key];
      });
      this.business.businessLicenceUrl = detail.imgPath.split(',')[0] || '1';
      this.business.doorUrl = detail.imgPath.split(',')[8] || '1';
      this.business.cashierUrl = detail.imgPath.split(',')[11] || '1';
      this.business.shopUrl = detail.imgPath.split(',')[12] || '1';
      this.business.officeAreaUrl = detail.imgPath.split(',')[9] || '1';
      this.business.outsideOfficeBuildingUrl = detail.imgPath.split(',')[10] || '1';
      this.business.redbeanUrl = detail.imgPath.split(',')[13] || '1';
      this.business.financialRoomPic = detail.imgPath.split(',')[14] || '1';
      this.accArea = this.business.provinceName + this.business.countyName + this.business.cityName;
    }
    console.log(this.business);
  },
  methods: {
    confirm(value) {
      this.$http.post({
        url: '/csps-api/merchantManage/checkCityNo',
        data: {
          cityNo: value[1].code
        }
      }).then(res => {
        console.log(res);
        this.business.provinceId = value[0].code;
        this.business.provinceName = value[0].name;
        this.business.cityNo = value[1].code;
        this.business.cityName = value[1].name;
        this.business.countyName = value[2].name;
        this.business.countyId = value[2].code;
        this.show_area = false;
        this.accArea = value[0].name + value[1].name + value[2].name;
      }).catch(error => {
        console.log(error);
      });
    },
    validateMercName() {
      const myreg = /^[\u4e00-\u9fa5()（）0-9]{1,20}$/;
      if (myreg.test(this.business.mercName)) {
        this.errorMessage = '';
      } else {
        this.errorMessage = '商户名称格式错误';
      }
    },
    validateShortName() {
      const myreg = /^[\u4e00-\u9fa5()（）0-9]{1,10}$/;
      if (myreg.test(this.business.shortName)) {
        this.error_shortName = '';
      } else {
        this.error_shortName = '商户简称格式错误';
      }
    },
    onNavClick(index) {
      if (this.items[index].children.length === 0) {
        this.queryTwoCateType(index, this.items[index].cateRecordId);
      }
      this.mainActiveIndex = index;
    },
    onItemClick(data) {
      this.activeId = data.id;
      console.log(data);
      this.business.scopBus = data.text;
      this.business.mercMcc = data.id;
      this.scopBusShow = false;
    },
    selectScop() {
      this.scopBusShow = true;
    },
    queryCateType() {
      this.$http.post({
        url: '/csps-api/base/mcc/selType',
        data: {}
      }).then(res => {
        console.log(res);
        res.data.result.forEach(item => {
          this.items.push({
            text: item.cateType,
            cateRecordId: item.cateRecordId,
            children: []
          })
        });
        this.queryTwoCateType(0, this.items[0].cateRecordId);
      }).catch(error => {
        console.log(error);
      });
    },
    queryTwoCateType(index, id) {
      this.$http.post({
        url: '/csps-api/base/mcc/selDtTypeList',
        data: {
          categoryId: id
        }
      }).then(res => {
        console.log(res);
        let newItems = res.data.result.map(item => {
          return {
            text: item.mercMccName,
            id: item.mercMcc
          }
        });
        this.items[index].children = newItems;
      }).catch(error => {
        console.log(error);
      });
    },
    changeAddress() {
      this.show_area = true;
    },
    checkChinese(val){
        var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
        if(reg.test(val)){
           return true;
        }
        return false;
    },
    uploadImgType(name) {
      switch (name) {
        case 'businessLicenceUrl':
          this.imgType = '1';
          break;
        case 'doorUrl':
          this.imgType = '9';
          break;
        case 'cashierUrl':
          this.imgType = '10';
          break;
        case 'shopUrl':
          this.imgType = '11';
          break;
        case 'officeAreaUrl':
          this.imgType = '12';
          break;
        case 'outsideOfficeBuildingUrl':
          this.imgType = '13';
          break;
        case 'redbeanUrl':
          this.imgType = '14';
          break;
        case 'financialRoomPic':
          this.imgType = '15';
          break;
        default:
          this.imgType = '';
          break;
      }
    },
    uploadImg(file, name) {
      this.$http.post({
        url: '/csps-api/merchantManage/ocrAgentImage',
        data: {
          type: this.imgType,
          file
        }
      }).then(res => {
        console.log(res);
        this.isUploadSuccess[name] = '0';
        this.loading.clear();
        this.business[name] = res.data.result.fileName;
      }).catch(error => {
        this.isUploadSuccess[name] = '1';
        console.log(error);
      });
    },
    formatterTime(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let days = date.getDate();
      if (month < 10) {
        month = '0' + month;
      };
      if (days < 10) {
        days = '0' + days;
      };
      return year + '-' + month + '-' + days;
    },
    selectDate(key) {
      this.show_time = true;
      this.key = key;
    },
    sureClick_time(data) {
      this.show_time = false;
      this.business[this.key] = this.formatterTime(new Date(data)); 
      console.log(data);
    },
    cancelClick() {
      this.show_time = false;
    },
    onRead(file, detail) {
      this.uploadImgType(detail.name);
      this.loading = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner'
      });
      var self = this;
      var img = new Image();
      img.src = file.content;
      img.onload = function() {
        var that = this;
        var w = that.width;
        var h = that.height;
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var cxt = canvas.getContext('2d');
        cxt.drawImage(that, 0, 0, w, h);
        var base64Data = canvas.toDataURL('image/jpeg', 0.8);
        var imgBase64 = base64Data.replace(/^data:image\/\w+;base64,/, '');
        self.imgSrc[detail.name] = base64Data;
        self.uploadImg(imgBase64, detail.name);
      };
    },
    gotoAccountInfo() {
      console.log(this.business);
      if (this.checkChinese(this.business.busLicNo)) {
        this.$toast('营业执照号不能包含中文');
        return;
      }
      if (this.business.busLicNo && this.business.busLicNo.length > 20) {
        this.$toast('营业执照号长度超限');
        return;
      }
      const isNull = Object.keys(this.business).every(item => {
        if (this.business[item] === '') {
          this.$toast(this.errorNotice[item]);
          return false;
        }
        return true;
      });
      if (isNull && this.errorMessage === '' && this.error_shortName === '') {
        this.$store.dispatch('submitMerchantInfo', this.business);
        this.$router.push('/merchant/accountInfo');
      }
    }
  }
};
</script>

<style scoped>
.cell_left_text{
  max-width: 120px;
}
.leftText{
  /*text-align: left;*/
}
.title{
  font-size: 14px;
  color: #474A56;
  padding: 15px 0;
}
.uploader{
  width: 100%;
  border: 1px dashed #979797;
}
.cameraBox{
  padding: 20% 0;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.cameraBox>div{
  text-align: center;
  color: #9B9B9B;
  font-size: 14px;
}
.cameraBox>div>img{
  width: 40px;
}
.cameraBox>img.previewImg{
  position: absolute;
  width: 100%;
  height: 100%;
  /*z-index: 10;*/
  left: 0;
  top: 0;
}
.cameraBox>img.statusImg{
  position: absolute;
  width: 30px;
  height: 30px;
  /*z-index: 10;*/
  left: 50%;
  top: 50%;
  transform: translate(-15px, -15px);
}
.btn{
  display: block;
  background-color: #1D7BF9;
  margin: 10% 0;
  width: 100%;
  line-height: 40px;
  border-radius: 20px;
  border: none;
  outline: none;
  color: #ffffff;
}
.bottomPopup{
  height: 50%;
}
</style>